module.exports = __webpack_public_path__ + "static/media/06_negro.b43b14b7.svg";